import { useStatsigClient } from '@statsig/react-bindings';

/**
 * Hook to check if a feature flag is enabled
 * @param featureName - The name of the feature flag to check
 * @returns boolean - Whether the feature is enabled
 */
export const useFeatureFlag = (featureName: string): boolean => {
  const { client, isLoading } = useStatsigClient();

  if (isLoading || !client) {
    return false;
  }

  try {
    return client.checkGate(featureName);
  } catch (error) {
    console.error(`Error checking feature flag ${featureName}:`, error);
    return false;
  }
};

export const FEATURE_FLAGS = {
  AddressMFE: 'del-838-address-mfe',
  CustomerPortalFinancials: 'firp-4578-customer-portal-beta-release',
};
